import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import Env from '@ridango/core/env';

@Injectable({
    providedIn: 'root'
})
export class PersonalizeService {
    constructor(
        @Inject('ENV') private env: Env,
        private http: HttpClient
    ) {}

    postPerso(payload): Observable<any> {
        payload['region_id'] = this.env.REGION_ID;
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/personalize/anon`;
        return this.http.post(url, payload);
    }

    postPersoAuth(payload): Observable<any> {
        const url = `${this.env.API_BASE_URL}/${this.env.REGION_ID}/personalize/auth`;
        return this.http.post(url, payload);
    }

    postPersoNoIssue(payload): Observable<any> {
        const url = `${this.env.API_GATEWAY_URL}/core/partner/v1/service/customer/personalization/no-issue`;
        return this.http.post(url, payload);
    }
}
